import axios from '../../axios/index.js'
export default {
    getEmployeeByUserId(userId) {
        return axios.get(`/api/users/${userId}`)
    },
    getAllEmployee(pageNumber, pageSize) {
        return axios.get(`/api/users/${pageNumber}/${pageSize}`)
    },
    getAllApproversByUserId(userId) {
        return axios.get('/api/hrms/approvers/' + userId)
    },
    getAllApproversByModule(module, userId) {
        return axios.get(`/api/hrms/approvers/getapproversbymodule/${module}/${userId}`).catch((error) => { console.log(error) })
    },
    getAllAccreditation(userId) {
        return axios.get(`/api/hrms/accreditation/${userId}`)
    },
    getAllAssociation(userId) {
        return axios.get(`/api/hrms/association/${userId}`)
    },
    getAllBankInformation(userId) {
        return axios.get(`/api/hrms/bankInformation/${userId}`)
    },
    getAllBenefits(userId) {
        return axios.get(`/api/hrms/benefits/${userId}`)
    },
    getAllClaimsLimit(userId) {
        return axios.get(`/api/hrms/claimsLimit/${userId}`)
    },
    getAllContactReferences(userId) {
        return axios.get(`/api/hrms/contactReferences/${userId}`)
    },
    getAllEducation(userId) {
        return axios.get(`/api/hrms/education/${userId}`)
    },
    getAllFamilyInformation(userId) {
        return axios.get(`/api/hrms/familyInformation/${userId}`)
    },
    getAllIdentification(userId) {
        return axios.get(`/api/hrms/identification/${userId}`)
    },
    getAllInformation(userId) {
        return axios.get(`/api/hrms/information/${userId}`)
    },
    getAllJobHistory(userId) {
        return axios.get(`/api/hrms/jobHistory/${userId}`)
    },
    async getAllLeaveBalance(userId) {
        return await axios.get(`/api/hrms/leaveBalance/${userId}`)
    },
    async getAllLeaveBenefits(userId) {
        return await axios.get(`/api/hrms/leaveBenefits/${userId}`)
    },
    getAllMedical(userId) {
        return axios.get(`/api/hrms/medical/${userId}`)
    },
    getAllPerformance(userId) {
        return axios.get(`/api/hrms/performance/${userId}`)
    },
    getAllSalaryInformation(userId) {
        return axios.get(`/api/hrms/salaryInformation/${userId}`)
    },
    getAllSalary(userId) {
        return axios.get(`/api/hrms/salary/${userId}`)
    },
    getAllTraining(userId) {
        return axios.get(`/api/hrms/training/${userId}`)
    },
    getAllViolation(userId) {
        return axios.get(`/api/hrms/violation/${userId}`)
    },
    
}